import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import TransactionTypeMappingMaintenanceCont from "presentation/view/container/TransactionTypeMapping/TransactionTypeMappingContMain";

CommonEntrypoint(<TransactionTypeMappingMaintenanceCont/>)